import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    captcha: ""
  });

  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const validUser = {
    username: "admin",
    password: "Admin@123"
  };

  const captchaText = "8yJA"; // static for now

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (formData.captcha !== captchaText) {
      setSuccess(false);
      setMessage("Invalid CAPTCHA");
      return;
    }

    if (
      formData.username === validUser.username &&
      formData.password === validUser.password
    ) {
      setSuccess(true);
      setMessage("Login successful!");
      setTimeout(() => {
        navigate("/taadmin");
      }, 1000);
    } else {
      setSuccess(false);
      setMessage("Invalid username or password.");
    }
  };

  return (
    <div style={styles.container}>
      
      {/* LEFT SIDE */}
      <div style={styles.left}>
        <img
          src="assets/images/Transactionemblem.png" // 👈 your logo path
          alt="TA Logo"
          style={styles.logo}
        />
        <h2 style={styles.leftTitle}>Welcome to TA Portal</h2>
        <p style={styles.leftText}>
          Secure enterprise dashboard for managing operations efficiently.
        </p>
      </div>

      {/* RIGHT SIDE LOGIN CARD */}
      <div style={styles.right}>
        <div style={styles.card}>
          <h2 style={styles.heading}><b>Sign In</b></h2>
          <p style={styles.subheading}>
            
          </p>

          <form onSubmit={handleLogin} style={styles.form}>
            <input
              type="text"
              name="username"
              placeholder="Username / Email / Mobile"
              value={formData.username}
              onChange={handleChange}
              style={styles.input}
              required
            />

            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              style={styles.input}
              required
            />
<p style={styles.helperText}>
  Password must be at least 8 characters long and include:
  <br />• Uppercase letters (A–Z)
   • Lowercase letters (a–z)
  <br />• a number (0–9)
  • a special character (e.g., @, #, $, %, &)
</p>
            {/* CAPTCHA */}
            <div style={styles.captchaRow}>
              <input
                type="text"
                name="captcha"
                placeholder="Enter CAPTCHA"
                value={formData.captcha}
                onChange={handleChange}
                style={{ ...styles.input, flex: 1, marginBottom: 0 }}
                required
              />

              <div style={styles.captchaBox}>{captchaText}</div>
            </div>

            <button type="submit" style={styles.button}>
              Login
            </button>

            {message && (
              <p
                style={{
                  color: success ? "#28a745" : "#dc3545",
                  marginTop: "12px"
                }}
              >
                {message}
              </p>
            )}
          </form>

          <p style={styles.forgot}>Forgot password?</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Arial, sans-serif"
  },

  /* LEFT SIDE */
  left: {
    flex: 1,
    background: "linear-gradient(135deg, #29872c, #2c5364)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    textAlign: "center"
  },
  logo: {
    width: "120px",
    marginBottom: "20px"
  },
  leftTitle: {
    fontSize: "28px",
    marginBottom: "10px"
  },
  leftText: {
    fontSize: "14px",
    opacity: 0.8
  },

  /* RIGHT SIDE */
  right: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fa"
  },

  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
  },

  heading: {
    textAlign: "center",
    marginBottom: "8px",
    
  },
  subheading: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#666"
  },

  form: {
    display: "flex",
    flexDirection: "column"
  },

  input: {
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  },

  helperText: {
    fontSize: "12px",
    color: "#777",
    marginBottom: "10px"
  },

  captchaRow: {
    display: "flex",
    gap: "10px",
    marginBottom: "15px"
  },

  captchaBox: {
    padding: "12px",
    background: "#e3f2fd",
    borderRadius: "8px",
    fontWeight: "bold",
    letterSpacing: "2px"
  },

  button: {
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#22c55e",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer"
  },

  forgot: {
    textAlign: "center",
    marginTop: "15px",
    color: "#22c55e",
    cursor: "pointer"
  }
};

export default LoginPage;